import React from 'react';
import CybsChip from '@cybs-ui/components/lib/chip';
import {connect} from 'react-redux';
import $ from 'jquery';

class MethodType extends React.Component{

  render(){
    return(
      <CybsChip id = "methodType" className= "bg_color_theme_primary border_color_theme_primary" dataTest="default">{this.props.methodType && this.props.methodType.toUpperCase()}</CybsChip>
    )     
  }
}

function mapStateToProps(state){
  setTimeout(function(){$('#methodType').addClass("bg_color_theme_primary");});
  return{
    methodType: state.lhsReducer.methodType
  }
}

export default connect(mapStateToProps)(MethodType);
